import { createAction } from 'redux-actions'

export const fetchLinks = createAction('static/links/FETCH')
export const fetchLinksSuccess = createAction('static/links/FETCH_SUCCESS')
export const fetchLinksFail = createAction('static/links/FETCH_FAIL')
